// Mouvement du site : les apparitions du contenu, les gestes de chaque section et l'empilement des
// sections. Module branché par main.ts, qui importe sa feuille. Il ne lit que des attributs
// data-motion (apparitions.ts, gestes.ts), data-renvoi (renvois.ts) et les sections [data-nav]
// (empilement.ts, intercalaires.ts).
//
// Sans JS, ou avant lui, tout est en place. En mouvement réduit : pas d'empilement, et les
// apparitions sont de courts fondus.

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import { appliquerApparitions } from './apparitions.ts';
import { monterEmpilement } from './empilement.ts';
import './mouvement.scss';

gsap.registerPlugin(ScrollTrigger);

/** Pose le mouvement dans la page ; rend la fonction qui l'en retire. */
export function monterMouvement(): () => void {
  const html = document.documentElement;
  html.classList.add('a-mouvement');
  const mm = gsap.matchMedia();
  let retire = false;
  // Après les polices : les lignes se coupent et les nombres se mesurent dans la vraie police.
  void document.fonts.ready.then(() => {
    if (retire) return;
    mm.add(
      {
        plein: '(prefers-reduced-motion: no-preference)',
        reduit: '(prefers-reduced-motion: reduce)',
      },
      (ctx) => {
        const plein = Boolean(ctx.conditions?.plein);
        const retirerApparitions = appliquerApparitions(plein);
        // L'empilement vient après les apparitions : leurs déclencheurs se mesurent dans le flux.
        const retirerEmpilement = plein ? monterEmpilement() : undefined;
        return () => {
          retirerEmpilement?.();
          retirerApparitions();
        };
      },
    );
    // Le héros attendait ce moment pour se montrer (mouvement.scss).
    html.classList.add('mouvement-pret');
    ScrollTrigger.refresh();
  });
  return () => {
    retire = true;
    mm.revert();
    html.classList.remove('a-mouvement', 'mouvement-pret');
  };
}
